import { render, staticRenderFns } from "./BillingLists.vue?vue&type=template&id=80587a3c&"
import script from "./BillingLists.vue?vue&type=script&lang=js&"
export * from "./BillingLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BillingLists.vue"
export default component.exports